import { Claims,ClaimsActionTypes,UPDATE_CLAIMS } from "./types";

export function updateClaims(claimsState: Claims): ClaimsActionTypes {
    return {
        type: UPDATE_CLAIMS,
        payload: claimsState
    };
}